import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Container from "../../../../../modules/commons/Container";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import * as ErrorAction from "../../../../../Redux/ErrorRedux";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { mapToObjectDDL } from "../../../../common/mapper";
import { monthOptions, yearOptions } from "./config";
import ReportStatistic from "./reportStatistic";

class ProspectMonitoringTeam extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dataCabang: [],
            kodeCabang: null,
            teamLead: null,
            month:null,
            year:null,
            idLeader: null,
            searchKey: 0,
            search: {
                month:null,
                year:null,
                kodeCabang:null
            },
        };
    };

    componentDidMount = async () => {
        this.fetchDataCabang();
        this.fetchLeaderId();
        let currentDate = new Date();

        this.setState((prevValue) => ({
          ...prevValue,
          month: monthOptions.find(
            (item) => item.value === currentDate.getMonth() + 1
          ),
          year: yearOptions.find(
            (item) => item.value === currentDate.getFullYear()
          ),
        }));
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({...prevValue, loading: !prevValue.loading,}));
    };

    fetchDataCabang = async () => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
            setError: this.props.setError,
            menuName: "Dashboard Level CRM Salesman CS - Laporan Prospek Daily",
            args: null,
        });
        if (res.ok) {
            let filteredData = res.data.data.filter(
                item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
            );

            if (filteredData.length !== 0) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataCabang: filteredData,
                    kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang)
                }))
            }
        }
        this.handleTriggerLoading();
    };

    fetchLeaderId = async () => {
        let idLeader = localStorage.getItem("idLeader");
        if (idLeader) {
            this.setState((prevValue) => ({
                ...prevValue,
                idLeader: idLeader,
            }));
            return;
        }
        
        this.handleTriggerLoading();
        try {
            let res = await fetchDataAsync({
                asyncFn: () => Api.create("NAGAMAS_MASTER_DATA").findUserById(this.props.auth?.user?.idUser),
                menuName: "Dashboard Level Team Leader - Laporan Harian By Team Leader",
                setError: this.props.setError,
            });
            console.log(res);
            
            if (res.ok) {
                localStorage.setItem("idLeader", res.data.data.id);
                this.setState((prevValue) => ({
                    ...prevValue,
                    idLeader: res.data.data.id,
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
        this.handleTriggerLoading();
    }

    handleSearchValueChange = async (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
        if (R.equals(name, "kodeCabang")) {
            this.setState((prevValue) => ({
                ...prevValue,
                teamLead: null,
            }));
        }
    };

    handleSearch = () => {
      this.setState((prev) => ({
        ...prev,
        searchKey: prev.searchKey + 1,
        search: {
          kodeCabang: this.state.kodeCabang?.value,
          month: this.state.month?.value,
          year: this.state.year?.value,
        },
      }));
    }

    render() {
        return (
          <>
            <Container>
              <FlexView style={{ gap: "20px", alignItems: "center" }}>
                <SimpleDDL
                  id="select_options_kode_cabang"
                  box="search"
                  name="kodeCabang"
                  isClearable
                  containerclassname="width width-250px"
                  placeholder="Nama Cabang"
                  menuPosition="fixed"
                  options={this.state.dataCabang.map((item) =>
                    mapToObjectDDL(item.namaDealer, item.kodeCabang)
                  )}
                  value={this.state.kodeCabang}
                  onChange={(value, { name }) =>
                    this.handleSearchValueChange(name, value)
                  }
                />
                <SimpleDDL
                  id="select_options_month"
                  box="search"
                  name="month"
                  isClearable
                  containerclassname="width width-250px"
                  placeholder="Bulan"
                  menuPosition="fixed"
                  options={monthOptions}
                  value={this.state.month}
                  onChange={(value, { name }) =>
                    this.handleSearchValueChange(name, value)
                  }
                />
                <SimpleDDL
                  id="select_options_year"
                  box="search"
                  name="year"
                  isClearable
                  containerclassname="width width-250px"
                  placeholder="Tahun"
                  menuPosition="fixed"
                  options={yearOptions}
                  value={this.state.year}
                  onChange={(value, { name }) =>
                    this.handleSearchValueChange(name, value)
                  }
                />
                <SimpleButton
                  styles={{ marginBottom: "15px" }}
                  onClick={() => this.handleSearch()}
                >
                  Cari
                </SimpleButton>
              </FlexView>
              <Tabs>
                <TabList>
                  <Tab>Laporan Statistik Prospek Per TL</Tab>
                  <Tab>Laporan Statistik Prospek Per Salesman / CS</Tab>
                </TabList>
                <TabPanel>
                  <ReportStatistic
                    {...this.props}
                    tab="tl"
                    search={this.state.search}
                    triggerLoading={this.handleTriggerLoading}
                    searchKey={this.state.searchKey}
                    idLeader={this.state.idLeader}
                  />
                </TabPanel>
                <TabPanel>
                  <ReportStatistic
                    {...this.props}
                    tab="salesman"
                    search={this.state.search}
                    kodeCabang={this.state.kodeCabang?.value}
                    triggerLoading={this.handleTriggerLoading}
                    searchKey={this.state.searchKey}
                    idLeader={this.state.idLeader}
                    userNameLead={this.props.auth?.user?.username}
                  />
                </TabPanel>
              </Tabs>
            </Container>
            {this.state.loading && (
              <SimpleLoadingOverlay active={this.state.loading} />
            )}
          </>
        );
    };
}

const mapStateToProps = state => {
  return {
    auth: state.auth
  }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ProspectMonitoringTeam);